import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import {
  Badge,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Table,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import isPermissionEnabled from "common/isPermissionEnabled"
import { getQuestionDetails } from "store/actions/ratingsAction"
import formatDateTime from "components/Shared/formatDateTime"
import { useTranslation } from "react-i18next"

const QuestionDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Rating Question Details | Sign Burger")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const { loading, isLoading, questionDetails } = useSelector(
    state => state.Ratings
  )

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      27,
      "rating_1",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
  }, [userRole])

  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    dispatch(getQuestionDetails(id))
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        {loading ? (
          <Card>
            <CardBody>
              <Row>
                <Col lg={12}>
                  <ShimmerThumbnail height={435} rounded />
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 d-flex align-items-center">
                    <BackButton /> {t("Question Details")}
                  </CardTitle>
                  <div>
                    {Object.values(questionDetails).length === 0 ? (
                      <p className="text-center my-2">
                        {t("No question details found")}
                      </p>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{questionDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Question(English)")}</th>
                            <td>{questionDetails?.question?.en || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Question(عربي)")}</th>
                            <td>{questionDetails?.question?.ar || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Question Type")}</th>
                            <td>
                              {questionDetails?.type === 0 && t("Star")}
                              {questionDetails?.type === 1 && t("Scale")}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Question Scale")}</th>
                            <td>{questionDetails?.scale}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Display Order")}</th>
                            <td>{questionDetails?.displayOrder}</td>
                          </tr>

                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {questionDetails.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Created At")}</th>
                            <td>
                              {formatDateTime(questionDetails?.createdAt)}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Updated At")}</th>
                            <td>
                              {formatDateTime(questionDetails?.updatedAt)}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default QuestionDetails
